import Page from '../pages/nova-area/page';
import DeleteConfirmationService from './services/delete-confirmation-service';

class BaseListPage extends Page {
    constructor(config = {}) {
        super(config);
        this.table = this.table ?? null;
    }

    onInit() {
        const tableId = this.config.tableId;
        if (!tableId) return;

        const rowActions = this._createRowActions();
        const tableConfig = {
            tableId,
            formId: `${tableId}-form`,
            containerId: `${tableId}-container`,
        };

        if (rowActions) {
            tableConfig.rowActions = rowActions;
        }

        this.table = new DataTable(tableConfig);
    }

    /**
     * Retorna a configuração de ações por linha para o DataTable.
     * Retorne `null` para páginas sem menu de ações (tabela read-only + botões inline).
     * @returns {Object|null}
     */
    _createRowActions() {
        return null;
    }

    async _confirmAndDelete(options = {}) {
        const deleted = await DeleteConfirmationService.execute({
            notification: this.notification,
            ...options,
        });

        if (deleted) {
            await this.table?.reload({ resetPage: true });
        }

        return deleted;
    }
}

export default BaseListPage;
